import { property, some, isNil, flow } from 'lodash';
import { createSelector, createStructuredSelector } from 'reselect';

const personalDataSlice = property('profile.personalData');
const avatarSlice = property('app.avatar');
const readOnlySlice = property('profile.readOnly');
const taxExemptionsSlice = property('profile.taxExemptions');
const userInfoSlice = property('app.user');

const dataSelectorFactory = (selector) =>
  createSelector(selector, (data) => data && data.get('data'));
const isErrorSelectorFactory = (selectorsArray) =>
  createSelector([...selectorsArray], (...results) =>
    some(results, (result) => result && result.get('error')),
  );
const isLoadingSelectorFactory = (selectorsArray) =>
  createSelector([...selectorsArray], (...results) =>
    some(
      results,
      (result) => (result && result.get('loading')) || (result && isNil(result.get('data'))),
    ),
  );

export const personalDataSelector = dataSelectorFactory(personalDataSlice);
export const avatarSelector = dataSelectorFactory(avatarSlice);
export const readOnlySelector = dataSelectorFactory(readOnlySlice);
export const taxExemptionsSelector = dataSelectorFactory(taxExemptionsSlice);
export const userInfoSelector = dataSelectorFactory(userInfoSlice);
export const innSelector = flow(
  userInfoSelector,
  (userData) => (userData && userData.get('inn')) || 'хххххххххххх',
);

export const dataToLoadPersonalData = createStructuredSelector({
  personalData: personalDataSlice,
  avatar: avatarSlice,
  readOnly: readOnlySlice,
  taxExemptions: taxExemptionsSlice,
  userInfo: userInfoSlice,
});

const requiredData = [personalDataSlice, readOnlySlice, taxExemptionsSlice];
export const personalDataIsErrorSelector = isErrorSelectorFactory(requiredData);
export const personalDataIsLoadingSelector = isLoadingSelectorFactory(requiredData);
